module.exports = __webpack_public_path__ + "media/images/front/top/solventum-40ac25237dca59e706c93b0607f1a62f.jpg";